import { useState } from "react";
import MobileHeader from "./Header";
import { Box, Typography, useTheme, Tabs, Tab } from "@mui/material";
import NotifStatusIcon from "../../../../media/images/icons/notif-status";

export default function NotifsPage() {
  const theme = useTheme();

  return (
    <>
      <MobileHeader />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          padding: "8px",
        }}
      >
        <NotifStatusIcon size={23} color={theme.palette.secondary.main} />

        <Typography
          sx={{
            fontWeight: "600",
          }}
          component="span"
          color="secondary.main"
        >
          اعلان های شما
        </Typography>

        {/* <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          شما
          <Typography
            sx={{
              fontWeight: "600",
            }}
            component="span"
            color="secondary.main"
          >
            {" 0 اعلان جدید "}
          </Typography>
          دارید
        </Typography> */}
      </Box>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>اعلانی وجود ندارد!</Typography>
      </Box>
      {/* <CustomTopTabbar
        setValue={setActiveTab}
        value={activeTab}
        tabs={["همه", "حساب کاربری", "اطلاعیه"].map((item, index) => (
          <NotifTabButton
            counts={0}
            label={item}
            active={index === activeTab}
          />
        ))}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>اعلانی وجود ندارد!</Typography>
        </Box>
      </CustomTopTabbar> */}
    </>
  );
}
